/* @flow */

import {createReducer} from 'redux-act';

import * as actions from './sales-actions';

const defaultStat = {value: 0, formatted: '0', prefix: '$', suffix: ''};
const defaultSummaryStats = {
    value: {mean: defaultStat, sum: defaultStat},
    openedTime: {mean: defaultStat},
    winRate: {value: defaultStat},
};

export const DEFAULT_ENGAGEMENT_SALES_STATE = {
    timeseriesChart: {
        isLoading: true,
        isTimedOut: false,
        isErrored: false,
        chartData: null,
        prefix: '$',
    },
    leadsList: {
        isLoading: true,
        isFirstLoad: true,
        errorMessage: undefined,
        listItems: [],
        meta: {},
    },
    summaryStats: {
        isLoading: true,
        stats: defaultSummaryStats,
    },
};

export const engagementSalesReducer = createReducer(
    {
        // $FlowIgnore - this works correctly from redux-act
        [actions.requestReportData]: (state) => {
            const newChartState = {
                ...state.timeseriesChart,
                isLoading: true,
                isTimedOut: false,
                isErrored: false,
            };

            return {...state, timeseriesChart: newChartState};
        },
        [actions.updateReportChartData]: (state, {chartData}) => {
            const newChartState = {
                ...state.timeseriesChart,
                isLoading: false,
                isTimedOut: false,
                isErrored: false,
                chartData,
            };

            return {...state, timeseriesChart: newChartState};
        },
        [actions.failReportChartData]: (state, err) => {
            if (err) {
                if (err.status === 504 || err.status === 502) {
                    const newChartState = {
                        ...state.timeseriesChart,
                        chartData: null,
                        isLoading: false,
                        isTimedOut: true,
                        isErrored: false,
                    };

                    return {...state, timeseriesChart: newChartState};
                } else {
                    const newChartState = {
                        ...state.timeseriesChart,
                        chartData: null,
                        isLoading: false,
                        isTimedOut: false,
                        isErrored: true,
                    };

                    return {...state, timeseriesChart: newChartState};
                }
            }

            return state;
        },
        // List reducers
        // $FlowIgnore - this works correctly from redux-act
        [actions.requestListData]: (state) => {
            return {
                ...state,
                leadsList: {...state.leadsList, isLoading: true, errorMessage: undefined},
                summaryStats: {...state.summaryStats, isLoading: true, stats: defaultSummaryStats},
            };
        },
        [actions.updateListData]: (state, {meta, listItems}) => {
            return {
                ...state,
                leadsList: {
                    ...state.leadsList,
                    isLoading: false,
                    isFirstLoad: false,
                    meta: meta,
                    listItems: listItems,
                    errorMessage: undefined,
                },
            };
        },
        [actions.updateListSummaryData]: (state, {meta}) => {
            return {
                ...state,
                summaryStats: {...state.summaryStats, isLoading: false, stats: meta.stats},
            };
        },
        [actions.failListData]: (state, err) => {
            return {
                ...state,
                leadsList: {
                    ...state.leadsList,
                    isLoading: false,
                    isFirstLoad: false,
                    errorMessage: err,
                },
            };
        },
    },
    DEFAULT_ENGAGEMENT_SALES_STATE
);
